<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <template v-if="permit">
      <permit-form
        :isLoading="isLoading"
        :onSubmit="onSubmit"
        :permit="permit"
      ></permit-form>
    </template>
  </v-container>
</template>

<!-- eslint-disable no-underscore-dangle -->
<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import PermitForm from './PermitForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { documentRegistry } = services;
const { permitService } = documentRegistry;

export default {
  name: 'PermitUpdate',
  components: {
    LandingCreate,
    PermitForm,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Service Agreement Update',
      enableBackButton: true,
    },
    permit: null,
  }),
  async created() {
    const { id } = this.$route.params;
    this.permit = await permitService.getOne({ id });
  },
  methods: {
    async onSubmit(dataChanges) {
      const data = Object.assign(this.permit || {}, dataChanges);

      this.isLoading = true;
      try {
        const { _id, _metadata } = this.permit;
        const permitData = {
          _id,
          _metadata,
          name: data.name,
          description: data.description,
        };
        await permitService.update({ permit: permitData });
        if (data.attachment) {
          const formData = new FormData();
          formData.append('attachment', data.attachment[0]);
          await permitService.upload({ id: _id, formData });
        }
        this.isLoading = false;

        this.$snackbar.showOk({ text: 'Successfully updated service agreement!' });
        this.$router.push({ name: 'permit.list' });
      } catch (e) {
        this.isLoading = false;
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
